import { Hero } from "@/components/home/Hero";
import { PainVsFix } from "@/components/home/PainVsFix";
import { ServicesTeaser } from "@/components/home/ServicesTeaser";
import { CTABand } from "@/components/site/Bands";
import { Dandelion } from "@/components/home/Dandelion";
import { WhoWeWorkWith } from "@/components/home/WhoWeWorkWith";
import { Testimonials } from "@/components/home/Testimonials";
import { Results } from "@/components/home/Results";
import { FAQ } from "@/components/home/FAQ";
import { SEO, orgSchema, websiteSchema, faqSchema, personSchema } from "@/components/site/SEO";
import { FAQS } from "@/data/site";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title="Organic Growth Partner for B2B SaaS & Tech Brands"
        description="Upword Media builds the full acquisition engine for B2B SaaS: content that ranks in Google and gets cited by ChatGPT & Perplexity, social and email that keep buyers warm, and conversion systems that turn traffic into pipeline."
        path="/"
        jsonLd={[orgSchema(), websiteSchema(), personSchema(), faqSchema(FAQS)]}
      />
      <Hero />
      <PainVsFix />
      <ServicesTeaser />
      <Dandelion />
      <WhoWeWorkWith />
      <Testimonials />
      <Results />
      <FAQ />
      <CTABand heading="Schedule a Content Audit. See exactly where your pipeline is leaking." showCaseStudies={false} />
    </div>
  );
}
